import React from 'react';
import { LineChart } from '../../../LineChart';
import { ChartLinePoint } from '../../../LineChart/LineChart.controller';

type EngagementChartViewProps = {
  dates: Date[];
  profileIds: string[];
  loading: boolean;
  firstDateFromData: string;
  lastDateFromData: string;
  isEmpty?: boolean;
  getValuesForChartCb?: () => ChartLinePoint[][];
  dateEndPrefillArea?: string;
  dateStartPrefillArea?: string;
};
export const EngagementChartView = ({
  dates,
  profileIds,
  loading,
  firstDateFromData,
  lastDateFromData,
  isEmpty,
  getValuesForChartCb,
  dateEndPrefillArea,
  dateStartPrefillArea
}: EngagementChartViewProps) => {
  return (
    <div className={'cell'}>
      <LineChart
        dates={dates}
        isEmpty={isEmpty}
        profileIds={profileIds}
        loading={loading}
        firstDateFromData={firstDateFromData}
        lastDateFromData={lastDateFromData}
        valueKeyString={'engagement'}
        valueKeyStringForAxisY={'engagement'}
        chartTitle={'Total Engagements'}
        chartSubTitle={'Total engagement, per profile, by day'}
        subTitleTooltipText={'Total likes, comments and shares combined'}
        getValuesForChartCb={getValuesForChartCb}
        dateEndPrefillArea={dateEndPrefillArea}
        dateStartPrefillArea={dateStartPrefillArea}
        shouldNormalize={false}
        isEngagementChart={true}
      />
    </div>
  );
};
